import { h } from "preact";

import { JiraAttachmentStatus } from "../../../../foundation/model/JiraAttachment";
import classname from "../../../../foundation/utils/classname";

import styles from "./JiraStatusTag.module.css";

type Props = {
    class?: string;
    status: JiraAttachmentStatus;
};

function JiraStatusTag({ class: cssClass, status }: Props) {
    const { statusCategory: { textColor, backgroundColor } } = status;
    return (
        <span
            className={classname(styles.jiraStatusTag, cssClass, "caption-2", "semibold", "ellipsis")}
            style={
                { backgroundColor: `rgba(${backgroundColor.r}, ${backgroundColor.g}, ${backgroundColor.b},${backgroundColor.a})`,
                    color: `rgba(${textColor.r}, ${textColor.g}, ${textColor.b}, ${textColor.a})` }
            }>
            {status.name}
        </span>
    );
}

export default JiraStatusTag;
